import { Fragment } from 'react';
import { Collapse } from 'reactstrap';

import { useOpenRequirement } from '../hooks/useOpenRequirement';
import {
  ElectiveRequirementsLoader,
  useElectiveRequirementsData,
} from '../loaders/ElectiveRequirementsLoader';
import ElectiveRequirementPanel from './ElectiveRequirementPanel';
import { Icon } from '@octano/global-ui';
import { ElectiveRequirementEnrollmentStatus } from '../types';

type AccordionListProps = {
  enrollmentStatus: ElectiveRequirementEnrollmentStatus;
  readOnly: boolean;
  hideStatusFilter: boolean;
};

function AccordionList({
  enrollmentStatus,
  readOnly,
  hideStatusFilter,
}: AccordionListProps) {
  const items = useElectiveRequirementsData();
  const { openTypeId, setOpenTypeId } = useOpenRequirement();

  return (
    <div className="p-3">
      {items.map((item) => {
        const isOpen = openTypeId === item.typeId;
        return (
          <Fragment key={item.typeId}>
            <button
              type="button"
              className="d-flex justify-content-between align-items-center w-100 border px-3 py-3 mb-2"
              onClick={() => setOpenTypeId(isOpen ? null : item.typeId)}
              style={{
                height: 60,
                backgroundColor: isOpen ? '#f5f5f5' : '#fff',
              }}
            >
              <span className="fw-700">{item.name}</span>
              <Icon name={isOpen ? 'chevron_up' : 'chevron_down'} />
            </button>
            <Collapse isOpen={isOpen} className="mb-3">
              {isOpen && (
                <ElectiveRequirementPanel
                  item={item}
                  readOnly={readOnly}
                  hideStatusFilter={hideStatusFilter}
                  enrollmentStatus={enrollmentStatus}
                />
              )}
            </Collapse>
          </Fragment>
        );
      })}
    </div>
  );
}

type ElectiveRequirementsTabProps = {
  enrollmentStatus: ElectiveRequirementEnrollmentStatus;
  readOnly: boolean;
  hideStatusFilter: boolean;
};

export default function ElectiveRequirementsTab({
  enrollmentStatus,
  readOnly,
  hideStatusFilter,
}: ElectiveRequirementsTabProps) {
  return (
    <ElectiveRequirementsLoader
      defaultQuery={{ enrollmentStatus }}
      fetchImmediately
    >
      <AccordionList
        enrollmentStatus={enrollmentStatus}
        hideStatusFilter={hideStatusFilter}
        readOnly={readOnly}
      />
    </ElectiveRequirementsLoader>
  );
}
